import { ApiError } from "src/features/Security/networking/types";

export enum CommonErrorOrigin {
    GET_COMPANY_BY_ID = 'GET_COMPANY_BY_ID',
    UPDATE_COMPANY_DATA = 'UPDATE_COMPANY_DATA',
    GET_ACTIVITY_LOG_RECORDS = 'GET_ACTIVITY_LOG_RECORDS',
}

export interface CommonError {
    type: CommonErrorOrigin,
    detail: ApiError
}

export interface GenericUpdateResult {
    success: boolean
}